const getStaffs = () => {
    const staffs = localStorage.getItem("staffs")
        ? JSON.parse(localStorage.getItem("staffs"))
        : null;

    return staffs;
};

const InitialState = {
    staffs: getStaffs(),
};

const StaffReducer = (state = InitialState, action) => {
    if (action.type === "Save_Staffs") {
        const newState = {
            ...state,
            staffs: action.payload,
        };
        localStorage.setItem("staffs", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("staffs");
        const newState = {
            staffs: null
        };
        return newState;
    }

    return state;
};

export default StaffReducer;